import { BubbleMenu, getMarkRange, getMarkType, getNodeType } from "@tiptap/react";
import _ from "lodash";
import { Button } from "reactstrap";
import { useEditorContext } from "../Wysiwyg";

export default function LinkBubbleMenu() {
  const { editor } = useEditorContext();

  if (!editor.isEditable) {
    return null;
  }

  const handlerStorage = editor.storage.linkBubbleMenuHandler;
  const menuState = handlerStorage.state;

  return (
    <BubbleMenu
      editor={editor}
      shouldShow={menuState !== "HIDDEN"}
      tippyOptions={{ placement: "bottom", delay: 0, offset: 10 }}
      className="tiptap-bubble-menu"
    >
      <ViewLinkMenuContent
        editor={editor}
        onRemove={() => {
          editor
            .chain()
            .unsetLink()
            .setTextSelection(editor.state.selection.to)
            .focus()
            .run();
        }}
      />
    </BubbleMenu>
  );
}

function ViewLinkMenuContent({ editor, onRemove }) {
  const linkRange = getMarkRange(
    editor.state.selection.$to,
    getMarkType("link", editor.schema)
  );
  const linkText = linkRange
    ? editor.state.doc.textBetween(linkRange.from, linkRange.to)
    : "";

  const currentHref = editor.getAttributes("link").href ?? "";

  if(!linkText) return;

  return (
    <div
      className="d-flex flex-column bg-white gap-1"
      style={{
        padding: "6px",
        border: "1px solid #ccc",
        boxShadow: "0 2px 4px rgba(0,0,0,.15)",
      }}
    >
      <div>
        {_.truncate(linkText, {
          length: 50,
          omission: "…",
        })}
      </div>

      <div>
        <a href={currentHref} target="_blank" rel="noopener">
          {_.truncate(currentHref, 50)}
        </a>
      </div>

      <div style={{ marginTop: "2px" }}>
        <Button onClick={onRemove} color="danger" size="sm">
          Törlés
        </Button>
      </div>
    </div>
  );
}
